/* ===========================
   FitMiss – Master Script (Stable Build)
   =========================== */

/* 1) Make price/hero cards clickable (with keyboard support) */
(function () {
  function wireCardClicks() {
    var cards = document.querySelectorAll('.fm-card--price, .fm-card--hero');
    cards.forEach(function (card) {
      var cta = card.querySelector('a[href*="/cart/"]');
      if (!cta) return;

      card.style.cursor = 'pointer';
      card.setAttribute('role', 'button');
      if (!card.hasAttribute('tabindex')) card.setAttribute('tabindex', '0');

      card.addEventListener('click', function (e) {
        if (e.target.closest('a, button, input, select, textarea')) return;
        window.location.assign(cta.href);
      });

      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          window.location.assign(cta.href);
        }
      });
    });

    var innerInteractives = document.querySelectorAll(
      '.fm-card--price a, .fm-card--price button, .fm-card--hero a, .fm-card--hero button'
    );
    innerInteractives.forEach(function (el) {
      el.addEventListener('click', function (e) { e.stopPropagation(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireCardClicks);
  } else {
    wireCardClicks();
  }
})();

/* 2) Progress circles (animate on view) */
document.addEventListener("DOMContentLoaded", function () {
  const configs = [
    { sel: ".fm-progress-89", value: 89 },
    { sel: ".fm-progress-94", value: 94 },
    { sel: ".fm-progress-98", value: 98 },
  ];

  function prep(el) {
    const fill = el.querySelector(".fm-fill");
    if (!fill) return;
    const r = parseFloat(fill.getAttribute("r"));
    const c = 2 * Math.PI * r;
    fill.style.strokeDasharray = c;
    fill.style.strokeDashoffset = c;
    el._circumference = c;
  }

  function animate(el, target, duration = 1600) {
    const fill = el.querySelector(".fm-fill");
    const num = el.querySelector(".fm-percent");
    if (!fill || !num) return;
    const C = el._circumference || 1;
    const start = performance.now();

    function tick(now) {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const current = Math.floor(eased * target);
      num.textContent = current + "%";
      fill.style.strokeDashoffset = C * (1 - (eased * target / 100));
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  const wrapper = document.querySelector(".fm-progress-wrapper");
  if (!wrapper) return;

  configs.forEach(cfg => {
    const el = document.querySelector(cfg.sel);
    if (el) prep(el);
  });

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        configs.forEach((cfg, i) => {
          const el = document.querySelector(cfg.sel);
          if (!el || el._played) return;
          el._played = true;
          setTimeout(() => animate(el, cfg.value), i * 150);
        });
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });

  io.observe(wrapper);
});

/* 3) Hero hover dims others (desktop) / on-view (mobile) */
document.addEventListener('DOMContentLoaded', function () {
  const hero = document.querySelector('.fm-card.fm-card--hero');
  const others = Array.from(document.querySelectorAll('.fm-card.fm-card--price'));
  if (!hero || !others.length) return;

  const isDesktopHover = matchMedia('(hover: hover) and (pointer: fine)').matches;

  function setDim(state) {
    others.forEach(card => card.classList.toggle('fm-dimmed', state));
  }

  if (isDesktopHover) {
    let t;
    hero.addEventListener('mouseenter', () => { clearTimeout(t); t = setTimeout(() => setDim(true), 100); });
    hero.addEventListener('mouseleave', () => { clearTimeout(t); setDim(false); });
    hero.addEventListener('focusin', () => setDim(true));
    hero.addEventListener('focusout', () => setDim(false));

    others.forEach(c => {
      ['mouseenter', 'focusin'].forEach(ev => c.addEventListener(ev, () => setDim(false)));
    });
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const heroCentered = entry.isIntersecting && entry.intersectionRatio >= 0.65;
        setDim(heroCentered);
      });
    }, { threshold: [0, 0.5, 0.65, 0.8, 1] });
    io.observe(hero);
  }
});

/* 4) Sticky header hide in pricing sections */
document.addEventListener('DOMContentLoaded', function () {
  var sticky = document.querySelector('.fm-sticky-menu');
  var sections = [
    document.getElementById('pricing-bundles'),
    document.getElementById('pricing-credits')
  ].filter(Boolean);
  if (!sticky || sections.length === 0) return;

  var REAPPEAR_OFFSET = 100;
  var headerH = 0;
  function measureHeader() {
    var r = sticky.getBoundingClientRect();
    headerH = Math.round(r.bottom - r.top);
  }
  measureHeader();
  window.addEventListener('resize', measureHeader, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(measureHeader).observe(sticky);

  function sectionActive(el) {
    var r = el.getBoundingClientRect();
    var touchesTop = (r.top <= headerH);
    var notPastBottom = (r.bottom > REAPPEAR_OFFSET);
    return touchesTop && notPastBottom;
  }

  function onScroll() {
    var hide = sections.some(sectionActive);
    sticky.classList.toggle('fm-hide', hide);
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { onScroll(); ticking = false; });
  }, { passive: true });

  onScroll();
});

/* 5) Reveal-on-scroll utility */
document.addEventListener('DOMContentLoaded', () => {
  const targets = [...document.querySelectorAll('.reveal, [data-stagger]')];
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach(el => el.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.18 });

  targets.forEach(el => io.observe(el));
});

/* 6) Confetti System — Adaptive + CTA + Full-Card (Final Version) */
(function () {
  let lastPos = { x: 0.5, y: 0.5 };
  window.addEventListener('pointerdown', e => {
    lastPos.x = e.clientX / window.innerWidth;
    lastPos.y = e.clientY / window.innerHeight;
  }, { capture: true, passive: true });

  const s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.6.0/dist/confetti.browser.min.js';
  s.onload = init;
  document.head.appendChild(s);

  // --- Adaptive profiles + helper utilities ---
  const FM_CONFETTI = {
    hero:   { particleCount: 90, spread: 72, startVelocity: 45, ticks: 120 },
    normal: { particleCount: 60, spread: 60, startVelocity: 35, ticks: 120 }
  };
  let fmConfettiLastAt = 0;

  function fmConfettiAllowed() {
    const now = performance.now();
    if (now - fmConfettiLastAt < 350) return false;
    fmConfettiLastAt = now;
    return true;
  }

  function fmGetConfettiProfile(isHero) {
    const w = window.innerWidth || 375;
    const dpr = window.devicePixelRatio || 1;
    const smallScreen = w < 380;
    const highDprSmall = dpr >= 3 && w <= 414;
    const lowPerf = smallScreen || highDprSmall;
    const base = isHero ? FM_CONFETTI.hero : FM_CONFETTI.normal;

    if (!lowPerf) return { ...base, scalar: 1 };
    return {
      particleCount: Math.round(base.particleCount * 0.7),
      spread: Math.round(base.spread * 0.9),
      startVelocity: Math.round(base.startVelocity * 0.9),
      ticks: Math.round(base.ticks * 0.75),
      scalar: 0.9
    };
  }

  // --- Main init after library loads ---
  function init() {
    function triggerConfetti(isHero, origin) {
      if (typeof confetti !== 'function') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!fmConfettiAllowed()) return;
      const cfg = fmGetConfettiProfile(isHero);
      confetti({ ...cfg, origin, colors: ['#ff6f61', '#ffdcd6', '#ffffff'] });
    }

    /* === CTA Buttons === */
    function bindButtons() {
      document.querySelectorAll('.fm-cta, .fm-card--price .fm-cta, .fm-card--hero .fm-cta')
        .forEach(btn => {
          if (btn.dataset.fmBound === '1') return;
          btn.dataset.fmBound = '1';

          btn.addEventListener('click', e => {
            const href = btn.getAttribute('href') || '';
            const isHero = !!btn.closest('.fm-card--hero');
            const targetSel = btn.dataset.scrollTarget || (href.startsWith('#') ? href : '');

            // --- Anchor / smooth scroll ---
            if (targetSel) {
              e.preventDefault(); e.stopPropagation();
              const target = document.querySelector(targetSel);
              if (!target) return;

              const rect = btn.getBoundingClientRect();
              const origin = {
                x: (rect.left + rect.width / 2) / window.innerWidth,
                y: (rect.top + rect.height / 2) / window.innerHeight
              };
              triggerConfetti(isHero, origin);

              const header = document.querySelector('.fm-sticky-menu');
              const offset = header ? (header.getBoundingClientRect().height || 0) : 0;
              const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
              requestAnimationFrame(() => {
                window.scrollTo({ top, behavior: 'smooth' });
              });
              return;
            }

            // --- Normal navigation ---
            if (href && href !== '#') {
              e.preventDefault(); e.stopPropagation();
              const rect = btn.getBoundingClientRect();
              const origin = {
                x: (rect.left + rect.width / 2) / window.innerWidth,
                y: (rect.top + rect.height / 2) / window.innerHeight
              };
              triggerConfetti(isHero, origin);
              setTimeout(() => window.location.href = href, 220);
            }
          });
        });
    }

    bindButtons();
    new MutationObserver(bindButtons).observe(document.documentElement, { childList: true, subtree: true });

    /* === Full-Card Confetti === */
    const cards = document.querySelectorAll('.fm-card--price, .fm-card--hero');
    cards.forEach(card => {
      if (card.dataset.fmCardConfetti === '1') return;
      card.dataset.fmCardConfetti = '1';

      card.addEventListener('click', e => {
        // Skip if CTA inside card already handled
        if (e.target.closest('.fm-cta')) return;

        const isHero = card.classList.contains('fm-card--hero');
        const origin = {
          x: e.clientX / window.innerWidth,
          y: e.clientY / window.innerHeight
        };
        triggerConfetti(isHero, origin);
      });
    });
  }
})();

/* 7) Scarcity Number (on-view + auto if visible) */
(function(){
  const IO_THRESHOLD = 0.15;
  const IO_ROOT_MARGIN = '0px 0px -15% 0px';

  function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }
  function clamp(n,min,max){ return Math.max(min, Math.min(max, n)); }
  function isVisible(el){
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh * 0.9 && r.bottom > vh * 0.1 && el.offsetParent !== null;
  }

  function animateCounter(el){
    if(!el || el.dataset.fmRunning === '1') return;
    el.dataset.fmRunning = '1';
    const num = el.querySelector('.fm-scarcity-num');
    if(!num){ el.dataset.fmRunning=''; return; }

    const target = clamp(parseInt(el.getAttribute('data-target')) || 74, 0, 100);
    const dur = parseInt(el.getAttribute('data-duration')) || 1400;
    num.textContent = '0%';
    const start = performance.now();

    function frame(now){
      const t = Math.min((now - start) / dur, 1);
      const eased = easeOutCubic(t);
      num.textContent = Math.round(eased * target) + '%';
      if(t < 1) requestAnimationFrame(frame);
      else el.dataset.fmRunning = '';
    }
    requestAnimationFrame(frame);
  }

  function watch(el){
    if(!el || el.dataset.fmObserved==='1') return;
    el.dataset.fmObserved='1';
    if(isVisible(el)){ animateCounter(el); return; }

    if('IntersectionObserver' in window){
      const io = new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting && entry.intersectionRatio >= IO_THRESHOLD){
            io.unobserve(entry.target);
            animateCounter(entry.target);
          }
        });
      },{threshold:IO_THRESHOLD,rootMargin:IO_ROOT_MARGIN});
      io.observe(el);
    }

    setTimeout(()=>{ if(isVisible(el)) animateCounter(el); },800);
  }

  function init(){
    document.querySelectorAll('.fm-scarcity-line').forEach(watch);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();

/* 8) Scarcity BAR (synced with number) */
(function(){
  const IO_THRESHOLD = 0.15;
  const IO_ROOT_MARGIN = '0px 0px -15% 0px';

  function isVisible(el){
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh * 0.9 && r.bottom > vh * 0.1 && el.offsetParent !== null;
  }

  function getTarget(bar){
    const prev = bar.previousElementSibling;
    if(prev && prev.classList.contains('fm-scarcity-line'))
      return parseInt(prev.getAttribute('data-target')) || 74;
    return parseInt(bar.getAttribute('data-target')) || 74;
  }

  function animateBar(bar){
    if(!bar || bar.dataset.fmBarRunning==='1') return;
    bar.dataset.fmBarRunning='1';
    const fill = bar.querySelector('.fm-scarcity-bar__fill');
    if(!fill){ bar.dataset.fmBarRunning=''; return; }
    const target = getTarget(bar);
    fill.style.transition = 'width 1.4s cubic-bezier(0.22, 1, 0.36, 1)';
    fill.style.width = '0%';
    void fill.offsetWidth;
    requestAnimationFrame(()=>{ fill.style.width = target + '%'; });
    setTimeout(()=> bar.dataset.fmBarRunning='',1500);
  }

  function watch(bar){
    if(!bar || bar.dataset.fmObserved==='1') return;
    bar.dataset.fmObserved='1';
    if(isVisible(bar)){ animateBar(bar); return; }

    if('IntersectionObserver' in window){
      const io = new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting && entry.intersectionRatio>=IO_THRESHOLD){
            io.unobserve(entry.target);
            animateBar(entry.target);
          }
        });
      },{threshold:IO_THRESHOLD,rootMargin:IO_ROOT_MARGIN});
      io.observe(bar);
    }

    setTimeout(()=>{ if(isVisible(bar)) animateBar(bar); },800);
  }

  function init(){
    document.querySelectorAll('.fm-scarcity-bar').forEach(watch);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
/* ===== FM Scarcity (minimal, isolated) ===== */
(function(){
  var IO_THRESHOLD = 0.15;
  var IO_ROOT_MARGIN = '0px 0px -15% 0px';

  function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }
  function clamp(n,min,max){ return Math.max(min, Math.min(max, n)); }
  function isVisible(el){
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return el.offsetParent !== null && r.top < vh*0.9 && r.bottom > vh*0.1;
  }

  function animateNumber(line){
    if(!line || line.dataset.fmNumRunning==='1') return;
    var num = line.querySelector('.fm-scarcity-num'); if(!num) return;
    line.dataset.fmNumRunning='1';

    var target = clamp(parseInt(line.getAttribute('data-target'))||74,0,100);
    var dur = parseInt(line.getAttribute('data-duration'))||1400;

    num.textContent = '0%';
    var start = performance.now();
    function frame(now){
      var t = Math.min((now - start)/dur, 1);
      num.textContent = Math.round(easeOutCubic(t)*target) + '%';
      if(t < 1) requestAnimationFrame(frame);
      else line.dataset.fmNumRunning='';
    }
    requestAnimationFrame(frame);
  }

  function animateBar(bar, target, dur){
    if(!bar || bar.dataset.fmBarRunning==='1') return;
    var fill = bar.querySelector('.fm-scarcity-bar__fill'); if(!fill) return;
    bar.dataset.fmBarRunning='1';

    // ensure transition duration matches number
    fill.style.transition = 'width '+(dur||1400)+'ms cubic-bezier(0.22,0.61,0.36,1)';
    fill.style.width = '0%';
    void fill.offsetWidth; // Safari reflow
    requestAnimationFrame(function(){
      fill.style.width = (target||74) + '%';
      setTimeout(function(){ bar.dataset.fmBarRunning=''; }, (dur||1400)+80);
    });
  }

  function pairAndRun(line){
    if(!line) return;
    // run number
    animateNumber(line);

    // find bar immediately after the line (allow one non-element in between)
    var n = line.nextElementSibling;
    while(n && !n.classList.contains('fm-scarcity-bar')) n = n.nextElementSibling;
    var bar = n;
    var target = clamp(parseInt(line.getAttribute('data-target'))||74,0,100);
    var dur = parseInt(line.getAttribute('data-duration'))||1400;
    if(bar) animateBar(bar, target, dur);
  }

  function watch(line){
    if(!line || line.dataset.fmObserved==='1') return;
    line.dataset.fmObserved='1';

    if(isVisible(line)){ pairAndRun(line); return; }

    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting && entry.intersectionRatio >= IO_THRESHOLD){
            io.unobserve(entry.target);
            pairAndRun(entry.target);
          }
        });
      }, { threshold: IO_THRESHOLD, rootMargin: IO_ROOT_MARGIN });
      io.observe(line);
    } else {
      function onScroll(){
        if(isVisible(line)){
          window.removeEventListener('scroll', onScroll, {passive:true});
          window.removeEventListener('resize', onScroll);
          pairAndRun(line);
        }
      }
      window.addEventListener('scroll', onScroll, { passive:true });
      window.addEventListener('resize', onScroll);
      setTimeout(onScroll, 500);
    }

    // safety nudge for late mounts
    setTimeout(function(){
      if(isVisible(line) && !line.dataset.fmNumRunning) pairAndRun(line);
    }, 800);
  }

  function init(){
    document.querySelectorAll('.fm-scarcity-line').forEach(watch);

    // replay after back/forward cache
    window.addEventListener('pageshow', function(){
      document.querySelectorAll('.fm-scarcity-line').forEach(function(line){
        line.dataset.fmObserved=''; line.dataset.fmNumRunning='';
        var bar = line.nextElementSibling;
        while(bar && !bar.classList.contains('fm-scarcity-bar')) bar = bar.nextElementSibling;
        if(bar){ bar.dataset.fmBarRunning=''; var fill = bar.querySelector('.fm-scarcity-bar__fill'); if(fill) fill.style.width = '0%'; }
        watch(line);
      });
    });

    // catch dynamic PageFly mounts
    document.addEventListener && document.addEventListener('pagefly:loaded', function(){
      document.querySelectorAll('.fm-scarcity-line').forEach(watch);
    });

    // mutation observer for late injections
    new MutationObserver(function(muts){
      muts.forEach(function(m){
        m.addedNodes && m.addedNodes.forEach(function(node){
          if(!(node instanceof Element)) return;
          if(node.matches && node.matches('.fm-scarcity-line')) watch(node);
          node.querySelectorAll && node.querySelectorAll('.fm-scarcity-line').forEach(watch);
        });
      });
    }).observe(document.documentElement, { childList:true, subtree:true });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // quick test helper: run in console to re-play instantly
  window.fmScarcityReplay = function(){
    document.querySelectorAll('.fm-scarcity-line').forEach(function(line){
      pairAndRun(line);
    });
  };
})();

// === Force-restart the hero CTA glow so it never "sticks" paused ===
(function () {
  function restartAnim(el) {
    if (!el) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // snapshot current animation value, kill it, force reflow, restore
    const prev = el.style.animation;
    el.style.animation = 'none';
    // force reflow (works across browsers)
    // eslint-disable-next-line no-unused-expressions
    el.offsetWidth;
    el.style.animation = prev || '';
  }

  function bind(btn) {
    if (!btn || btn.dataset.fmHeroGlowBound === '1') return;
    btn.dataset.fmHeroGlowBound = '1';

    // When pointer leaves / touch ends / element blurs, re-arm the glow
    ['mouseleave', 'touchend', 'blur'].forEach(evt =>
      btn.addEventListener(evt, () => restartAnim(btn), { passive: true })
    );
  }

  function init() {
    document.querySelectorAll('.fm-cta.fm-cta--hero').forEach(bind);
  }

  // run now + rebind if PageFly injects new DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });

  // Also re-arm when returning to the tab (fixes some Safari cases)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      document.querySelectorAll('.fm-cta.fm-cta--hero').forEach(restartAnim);
    }
  });
})();

/* === FitMiss: Generic opt-in smooth scroll (works for any data-scroll-target) === */
(function () {
  // we’ll only act on elements that explicitly opt-in via data-scroll-target
  const BTN_SELECTOR = '[data-scroll-target]';
  // don’t hijack CTAs inside these cards (checkout buttons)
  const EXCLUDE = '.fm-card--price, .fm-card--hero';

  document.addEventListener('click', function (e) {
    const btn = e.target.closest(BTN_SELECTOR);
    if (!btn) return;

    // skip price/hero cards so checkout CTAs behave normally
    if (btn.closest(EXCLUDE)) return;

    const selector = btn.getAttribute('data-scroll-target');
    if (!selector || !selector.startsWith('#')) return;

    const target = document.querySelector(selector);
    if (!target) return;

    e.preventDefault();
    e.stopPropagation();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, { capture: true, passive: false });
})();

/* === FitMiss Mobile Press Helper (Tactile Feedback for iOS/Android) === */
(function () {
  const SEL = '.fm-cta, .fm-cta-secondary';
  let pressedEl = null;

  document.addEventListener('touchstart', e => {
    const btn = e.target.closest(SEL);
    if (!btn) return;
    pressedEl = btn;
    btn.classList.add('is-tapping');
  }, { passive: true });

  ['touchend', 'touchcancel'].forEach(ev => {
    document.addEventListener(ev, () => {
      if (pressedEl) {
        pressedEl.classList.remove('is-tapping');
        pressedEl = null;
      }
    }, { passive: true });
  });
})();

